import { useMutation } from 'react-query';

import { updateProjectMeasurementSystem } from 'shared/api/projects/http';

const useMutateUpdateProjectMeasurementSystem = (options = undefined) =>
  useMutation(({ id, measurementSystem }) => updateProjectMeasurementSystem(id, measurementSystem), options);

export default useMutateUpdateProjectMeasurementSystem;
